export const NO_PHOTO_FILE_NAME = '#NoPhoto';

export const PHOTO_DEFAULT_VALUES = {
  ImageTypeCode: '',
  IsMark: false,
  IsDefault: false,
  MarkType: '',
  Location: '',
  Gang: '',
  Description: '',
};
